<template>
  <div class="">
    <Grid
      v-bind:style="{ height: gridHeight + 'px' }"
      :data-items="fileItem"
      @download="download"
      @remove="remove"
      @view="view"
      :columns="FileUploadcolumns"
    >
      <grid-toolbar>
        <div class="text-right">
          <input type="file" hidden ref="file" multiple="multiple" @change="uploadFiles">
          <button type="button" @click="$refs.file.click()" class="k-button k-primary">
            Add File
          </button>
        </div>
      </grid-toolbar>
    </Grid>
    <kendo-window
      ref="windowRef"
      :width="'600px'"
      :title="'Upload File'"
      :modal="true"
      style="display:none"
    >
      <div class>
        <upload ref="upload"
          name="files"
          :multiple="true"
          :async-save-url="'custom-save-url'"
          :async-remove-url="'custom-remove-url'"
          :files="files">
        </upload>
        <!-- <kendo-upload
          ref="upload"
          name="files"
          :async-save-url="'custom-save-url'"
          :async-remove-url="'custom-remove-url'"
          :async-auto-upload="false"
          :multiple="false"
          :template="template"
        ></kendo-upload> -->
      </div>
    </kendo-window>
  </div>
</template>
<script>
import Vue from "vue";
import CommandCell from "@/components/FileUploadCell/FileUploadCell.vue";
import { UploadInstaller } from "@progress/kendo-upload-vue-wrapper";
import { Upload } from '@progress/kendo-upload-vue-wrapper';
Vue.use(UploadInstaller);
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vehicle");
export default {
  data: function() {
    return {
      gridHeight: window.innerHeight - 150,
      vehicleData: {},
      FileUploadcolumns: [
        { field: "id", title: "S.No", width: "100px" },
        { field: "fileName", title: "File Name", width: "150px" },
        { field: "fileUrl", title: "File URL", width: "180px" },
        { field: "fileType", title: "File Type", width: "150px" },
        { cell: CommandCell, title: "Actions", width: "200px" },
      ],
      files: [],
      file: [],
      template:
        "<span class='k-progress'></span>" +
        "<div class='file-wrapper'>" +
        "<span class='file-icon img-file'></span>" +
        "<h4 class='file-heading file-name-heading'>Name: #=name#</h4>" +
        "<h4 class='file-heading file-size-heading'>Size: #=size# bytes</h4>" +
        "<strong class='k-upload-status'>" +
        "<button type='button' " +
        "class='k-upload-action'></button>" +
        "<button type='button' class='k-upload-action'></button>" +
        "</strong>" +
        "</div>",
    };
  },
  methods: {
    async view(e) {
      this.$store.dispatch("vehicle/viewFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["vehicle/fileUrlView"];
        console.log('Viewinf............... ', fileUrl);
        window.open(fileUrl, "_blank");
      });
    },
    download: function(e) {
      this.$store.dispatch("vehicle/downloadFile", e.dataItem.id).then(() => {
        const fileUrl = this.$store.getters["vehicle/fileUrlDownload"];
        console.log('Downloading............... ', fileUrl);
        window.open(fileUrl, "_blank");
      });
    },
    remove: function(e) {
      this.$store.dispatch("vehicle/deleteFile", e.dataItem).then(() => {
        // this.$store.dispatch("driver/getDriverFileList", this.vehicleData.id);
      });
      if(!e.dataItem.referenceID)
       {const index = this.file.map(item => item.id).indexOf(e.dataItem.id) 
           this.file.splice(index, 1)}
    },
    uploadFile() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().open();
      this.fileUpload();
    },
    fileUpload() {
      console.log('#FPF UPLOAD IS TAKING OFF');
      // var t = this;
      var postFormData = function(url, data, fileEntry, xhr) {
        let dataArray = []
        dataArray.push(data)
        console.log(dataArray)
        // t.$store
        //   .dispatch("driver/uploadFile", {
        //     data: data,
        //     id: t.vehicleData.id,
        //   })
        //   .then(() => {
        //     t.$store.dispatch("driver/getDriverFileList", t.vehicleData.id);
        //     t.fileClose();
        //     //t.upload._submitRemove = t.submitRemove;
        //   });
        var module = this;
        fileEntry.data("request", xhr);

        setTimeout(function() {
          var e = {
            target: { responseText: "", statusText: "OK", status: 200 },
          };
          module.onRequestSuccess.call(module, e, fileEntry);
        }, 1000);
      };
      var submitRemove = function(fileNames, eventArgs, onSuccess) {
        onSuccess();
      };

      var upload = this.$refs.upload.kendoWidget();
      upload._module.postFormData = postFormData;
      upload._submitRemove = submitRemove;
    },
    uploadFiles(){
      for( var i = 0; i < this.$refs.file.files.length; i++ ){
        this.$refs.file.files[i].id = "file"+Math.random(100, 10000)
        this.$store.commit("vehicle/addTempFile",this.$refs.file.files[i])
        this.file.push(this.$refs.file.files[i]);
        // formData.append('files[' + i + ']', file);
      }
    },
    submitFiles() {
    console.log("#FTS Submitting files ");
      //  var postFormData = function (url, data, fileEntry, xhr) {
      //       var module = this;
      //       fileEntry.data("request", xhr);
      //       setTimeout(function () {
      //           var e = { target: { responseText: '', statusText: "OK", status: 200 } };
      //           module.onRequestSuccess.call(module, e, fileEntry);
      //       }, 1000);
      //   };
      //    var submitRemove = function (fileNames, eventArgs, onSuccess) {
      //       onSuccess();
      //   };
      //   var upload = this.$refs.upload.kendoWidget();
      //   upload._module.postFormData = postFormData;
      //   upload._submitRemove = submitRemove;

    let formData = new FormData();
    // var t = this;
    for( var i = 0; i < this.file.length; i++ ){
        let file = this.file[i];
        formData.append('files[' + i + ']', file);
    }
    console.log('#FTS BULK FILES ', formData);
    this.$store.commit("vehicle/assignBulkFile",formData)
    console.log(formData)
    // t.$store
    //       .dispatch("driver/uploadFile", {
    //         data: formData,
    //         id: t.vehicleData.id,
    //       })
    },
    fileClose() {
      var window = this.$refs.windowRef.kendoWidget();
      window.center().close();
    },
  },
  computed: {
    ...mapState({
      fileItem: (state) => state.vehicleFileList,
    }),
  },
  beforeMount() {
    this.vehicleData = this.$store.getters["vehicle/vehicleData"];
    if (this.vehicleData.id !== undefined) {
      this.$store.dispatch("vehicle/getVehicleFileList", this.vehicleData.id);
    }
  },
  components: {
   'upload': Upload
  },
};
</script>
